<template>
  <form method="POST" v-on:submit="submitForm">
    <input type="hidden" name="_method" value="PUT">
    <input type="hidden" name="_token" :value="csrf">
    <div>
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <div class="px-4 sm:px-0">
            <h3 class="text-lg font-medium leading-6 text-gray-900">IT Contact Information</h3>
            <p class="mt-1 text-sm text-gray-600">This information helps Sonicu in the rare situation we have additional
              questions about your IT configuration.</p>
          </div>
        </div>
        <div class="mt-5 md:col-span-2 md:mt-0">
          <div class="overflow-hidden shadow sm:rounded-md">
            <div class="bg-white px-4 py-5 sm:p-6">
              <div class="grid grid-cols-6 gap-6">

                <div class="col-span-6">
                  <label for="contact-name" class="block text-sm font-medium text-gray-700">IT Contact Name</label>
                  <input v-model="section1ContactName"
                         type="text" name="contact-name" id="contact-name"
                         class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"/>
                </div>

                <div class="col-span-6">
                  <label for="contact-email" class="block text-sm font-medium text-gray-700">IT Contact Email
                    address</label>
                  <input v-model="section1ContactEmail"
                         type="email" name="contact-email" id="contact-email" autocomplete="email"
                         class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"/>
                </div>

                <div class="col-span-6">
                  <label for="contact-phone" class="block text-sm font-medium text-gray-700">IT Contact Phone #</label>
                  <input v-model="section1ContactPhone"
                         type="text" name="contact-phone" id="contact-phone" autocomplete="email"
                         class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"/>
                </div>

              </div>
            </div>
            <div class="bg-gray-50 px-4 py-3 text-right sm:px-6">
              <button
                @click="submitSectionOne"
                type="button"
                class="inline-flex justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                :class="canSubmitSection1 ? 'cursor-pointer hover:bg-blue-700 bg-blue-600' : 'cursor-not-allowed hover:bg-gray-700 bg-gray-600'"
              >
                {{ canSubmitSection1 ? 'Proceed' : 'Complete all fields' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="section1Complete" class="hidden sm:block" aria-hidden="true">
      <div class="py-5">
        <div class="border-t border-gray-200"/>
      </div>
    </div>

    <div v-show="section1Complete" class="mt-10 sm:mt-0">
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <div class="px-4 sm:px-0">
            <h3 class="text-lg font-medium leading-6 text-gray-900">Network Configuration</h3>
            <p class="mt-1 text-sm text-gray-600">Sonicu can configure and test network settings on your devices prior
              to
              shipping. To do so, select Option 1 below. You will be prompted to enter that information on the next page
              or call Sonicu Support at 317-468-2345 to provide this over the phone.</p>
          </div>
        </div>
        <div class="mt-5 md:col-span-2 md:mt-0">
          <div class="overflow-hidden shadow sm:rounded-md">
            <div class="space-y-6 bg-white px-4 py-5 sm:p-6">
              <fieldset>
                <legend class="contents text-base font-medium text-gray-900">How would you like your devices
                  configured?
                </legend>
                <p class="text-sm text-gray-500">PLEASE NOTE: If you select Option 1, Sonicu must receive your network
                  settings within 2 weeks or your order will default to Option 2. You'll then need to program your devices after they arrive at your
                  facility.</p>
                <div class="mt-4 space-y-4">
                  <div class="flex items-center">
                    <input id="network-preconfigured" name="network-configuration"
                           v-model="section2NetworkConfiguration"
                           value="network-preconfigured"
                           type="radio" class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"/>
                      <span class="inline-flex items-center rounded-full bg-blue-50 px-4 py-2 text-sm font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                          <div>
                              <b>Recommended</b> Option 1: I will provide Sonicu my network settings to configure devices prior to shipping.
                          </div>
                      </span>
                  </div>
                  <div class="flex items-center">
                    <input id="network-noconfiguration" name="network-configuration"
                           v-model="section2NetworkConfiguration"
                           value="network-noconfiguration"
                           type="radio" class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"/>
                    <label for="network-noconfiguration" class="ml-3 block text-sm font-medium text-gray-700">Option 2:
                      I prefer to configure my device settings AFTER they ship to my location.</label>
                  </div>
                    <div v-if="section2NetworkConfiguration === 'network-noconfiguration'"
                            class="rounded-md bg-yellow-50 p-4">
                        <div class="flex">
                            <div class="flex-shrink-0">
                                <svg class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="ml-3">
                                <h3 class="text-sm font-medium text-yellow-800">Attention needed</h3>
                                <div class="mt-2 text-sm text-yellow-700">
                                    <p>
                                        For customers using a WiFi connection, self-configuration will require you to manually connect to each device and apply
                                        configuration, which increases the time and complexity of your installation.
                                        Sonicu highly recommends that WiFi customers select Option 1.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
              </fieldset>
              <fieldset>
                <legend class="contents text-base font-medium text-gray-900">MAC Address Filtering</legend>
                <p class="text-sm text-gray-500">Does your network require specific MAC addresses to be explicitly
                  allowed?</p>
                <div class="mt-4 space-y-4">
                  <div class="flex items-center">
                    <input id="network-filtered" name="network-whitelisted"
                           v-model="section2NetworkFiltered"
                           value="network-filtered"
                           type="radio" class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"/>
                    <label for="network-filtered" class="ml-3 block text-sm font-medium text-gray-700">Yes, we require
                      MAC addresses to be explicitly allowed onto our network.</label>
                  </div>
                  <div class="flex items-center">
                    <input id="network-unfiltered" name="network-whitelisted"
                           v-model="section2NetworkFiltered"
                           value="network-unfiltered"
                           type="radio" class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"/>
                    <label for="network-unfiltered" class="ml-3 block text-sm font-medium text-gray-700">No, we do not
                      filter devices based upon MAC address</label>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="bg-gray-50 px-4 py-3 text-right sm:px-6">
              <button
                @click="submitSection2"
                type="button"
                class="inline-flex justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                :class="canSubmitSection2 ? 'cursor-pointer hover:bg-blue-700 bg-blue-600' : 'cursor-not-allowed hover:bg-gray-700 bg-gray-600'"
              >
                {{ canSubmitSection2 ? 'Proceed' : 'Complete all fields' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div v-show="section2Complete" class="hidden sm:block" aria-hidden="true">
      <div class="py-5">
        <div class="border-t border-gray-200"/>
      </div>
    </div>

    <div v-show="section2Complete" class="mt-10 sm:mt-0">
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <div class="px-4 sm:px-0">
            <h3 class="text-lg font-medium leading-6 text-gray-900">Network Information</h3>
            <p class="mt-1 text-sm text-gray-600">Please enter your WiFi network credentials below.</p>
            <p class="mt-1 text-sm text-gray-600">Note: Sonicu devices <b>WILL NOT</b> work on guest networks or
              networks
              with an authentication screen requiring login.</p>
          </div>
        </div>
        <div class="mt-5 md:col-span-2 md:mt-0">
          <div class="overflow-hidden shadow sm:rounded-md">
            <div class="space-y-6 bg-white px-4 py-5 sm:p-6">
              <fieldset>
                <legend class="contents text-base font-medium text-gray-900">WiFi Security Type</legend>
                <p class="text-sm text-gray-500">Please note: If using WPA2-Enterprise, Sonicu only supports WPA2-Enterprise with MSCHAPv2 Phase
                  2.</p>
                <p class="text-sm text-gray-500">Please note: Sonicu only supports 2.4GHz Wifi.</p>
                <div class="mt-4 space-y-4">
                  <div class="flex items-center">
                    <input id="wifi-wpa2psk" name="wifi-security"
                           v-model="section3SecurityType"
                           value="network-wpa2psk"
                           type="radio" class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"/>
                    <label for="wifi-wpa2psk" class="ml-3 block text-sm font-medium text-gray-700">WPA2-PSK</label>
                  </div>
                  <div class="flex items-center">
                    <input id="wifi-wpa2enterprise" name="wifi-security"
                           v-model="section3SecurityType"
                           value="network-wpa2enterprise"
                           type="radio" class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"/>
                    <label for="wifi-wpa2enterprise" class="ml-3 block text-sm font-medium text-gray-700">WPA2-Enterprise</label>
                  </div>
                  <div class="flex items-center">
                    <input id="wifi-unsecured" name="wifi-security"
                           v-model="section3SecurityType"
                           value="network-unsecured"
                           type="radio" class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"/>
                    <label for="wifi-unsecured" class="ml-3 block text-sm font-medium text-gray-700">No encryption (and
                      no login portal)</label>
                  </div>
                </div>
              </fieldset>
              <div v-show="askForWifiInfo"
                   class="grid grid-cols-6 gap-6">
                <div class="col-span-6">
                  <label for="contact-name" class="block text-sm font-medium text-gray-700">WiFi SSID</label>
                  <input v-model="section3WifiSsid"
                         type="text" name="wifi-ssid" id="wifi-ssid"
                         class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"/>
                </div>

                <div v-show="!isSection3EnterpriseWifi && section3SecurityType !== false && !isSection3Unsecured"
                     class="col-span-6">
                  <label for="wifi-passkey" class="block text-sm font-medium text-gray-700">WiFi Passkey</label>
                  <input v-model="section3WifiPasskey"
                         type="text" name="wifi-passkey" id="wifi-passkey" autocomplete="email"
                         class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"/>
                </div>
                <!--              todo: ADD FIELDSET FOR MULTIPLE 8021.X INFOS -->

                <div v-show="isSection3EnterpriseWifi"
                     class="col-span-6">
                  <label for="wifi-username" class="block text-sm font-medium text-gray-700">WPA2-Enterprise
                    Username</label>
                  <input v-model="section3EnterpriseWifiUsername"
                         type="text" name="wifi-username" id="wifi-username" autocomplete="email"
                         class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"/>
                </div>

                <div v-show="isSection3EnterpriseWifi"
                     class="col-span-6">
                  <label for="wifi-password" class="block text-sm font-medium text-gray-700">WPA2-Enterprise
                    Password</label>
                  <input v-model="section3EnterpriseWifiPassword"
                         type="text" name="wifi-password" id="wifi-password" autocomplete="email"
                         class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"/>
                </div>

              </div>
            </div>
            <div class="bg-gray-50 px-4 py-3 text-right sm:px-6">
              <button
                @click="submitSection3"
                type="button"
                class="inline-flex justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                :class="canSubmitSection3 ? 'cursor-pointer hover:bg-blue-700 bg-blue-600' : 'cursor-not-allowed hover:bg-gray-700 bg-gray-600'"
              >
                {{ canSubmitSection3 ? 'Proceed' : 'Complete all fields' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="section3Complete && askForWifiInfo" class="hidden sm:block" aria-hidden="true">
      <div class="py-5">
        <div class="border-t border-gray-200"/>
      </div>
    </div>

    <div v-show="section3Complete && askForWifiInfo" class="mt-10 sm:mt-0">
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <div class="px-4 sm:px-0">
            <h3 class="text-lg font-medium leading-6 text-gray-900">Advanced Network Settings (Optional)</h3>
          </div>
        </div>
        <div class="mt-5 md:col-span-2 md:mt-0">
          <div class="overflow-hidden shadow sm:rounded-md">
            <div class="space-y-6 bg-white px-4 py-5 sm:p-6">
              <fieldset>
                <legend class="contents text-base font-medium text-gray-900">IP Address Allocation</legend>
                <div class="mt-4 space-y-4">
                  <div class="flex items-center">
                    <input id="ip-dhcp" name="ip-allocation"
                           v-model="section4IpAllocation"
                           value="ip-dhcp"
                           type="radio" class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"/>
                    <label for="ip-dhcp" class="ml-3 block text-sm font-medium text-gray-700">DHCP (Default)</label>
                  </div>
                  <div class="flex items-center">
                    <input id="ip-static" name="ip-allocation"
                           v-model="section4IpAllocation"
                           value="ip-static"
                           type="radio" class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"/>
                    <label for="ip-static" class="ml-3 block text-sm font-medium text-gray-700">Static IP</label>
                  </div>
                </div>
              </fieldset>
              <div v-show="askForStaticIpInfo"
                   class="grid grid-cols-6 gap-6">
                <div class="col-span-6">
                  <label for="static-ip-range" class="block text-sm font-medium text-gray-700">Static IP Range</label>
                  <input v-model="section4IpStaticRange"
                         type="text" name="static-ip-range" id="static-ip-range"
                         class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"/>
                </div>
              </div>
              <fieldset>
                <legend class="contents text-base font-medium text-gray-900">DNS</legend>
                <div class="mt-4 space-y-4">
                  <div class="flex items-center">
                    <input id="dns-default" name="ip-dns"
                           v-model="section4Dns"
                           value="dns-default"
                           type="radio" class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"/>
                    <label for="dns-default" class="ml-3 block text-sm font-medium text-gray-700">8.8.8.8
                      (default)</label>
                  </div>
                  <div class="flex items-center">
                    <input id="dns-custom" name="ip-dns"
                           v-model="section4Dns"
                           value="dns-custom"
                           type="radio" class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"/>
                    <label for="dns-custom" class="ml-3 block text-sm font-medium text-gray-700">
                      <input placeholder="Custom DNS" v-model="section4DnsInput" type="text"
                             name="dns-custom"
                             class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"/>
                    </label>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend class="contents text-base font-medium text-gray-900">Protocol</legend>
                <p class="text-sm text-gray-500">Some customers prefer communication over a specific protocol -- this is
                  your opportunity to select one.</p>
                <p class="text-sm text-gray-500">Note: Binary TCP traffic can have issues with overly-aggressive network
                  traffic inspection hardware.</p>
                <div class="mt-4 space-y-4">
                  <div class="flex items-center">
                    <input id="ip-binary" name="ip-protocol"
                           v-model="section4Protocol"
                           value="ip-binary"
                           type="radio" class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"/>
                    <label for="ip-binary" class="ml-3 block text-sm font-medium text-gray-700">Binary TCP</label>
                  </div>
                  <div class="flex items-center">
                    <input id="ip-http" name="ip-protocol"
                           v-model="section4Protocol"
                           value="ip-http"
                           type="radio" class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"/>
                    <label for="ip-http" class="ml-3 block text-sm font-medium text-gray-700">HTTP</label>
                  </div>
                  <div class="flex items-center">
                    <input id="ip-https" name="ip-protocol"
                           v-model="section4Protocol"
                           value="ip-https"
                           type="radio" class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"/>
                    <label for="ip-https" class="ml-3 block text-sm font-medium text-gray-700">HTTPS</label>
                  </div>
                  <div class="flex items-center">
                    <input id="ip-all" name="ip-protocol"
                           v-model="section4Protocol"
                           value="ip-all"
                           type="radio" class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500"/>
                    <label for="ip-all" class="ml-3 block text-sm font-medium text-gray-700">All methods are
                      acceptable</label>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="bg-gray-50 px-4 py-3 text-right sm:px-6">
              <button
                @click="submitSection4"
                type="button"
                class="inline-flex justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                :class="canSubmitSection4 ? 'cursor-pointer hover:bg-blue-700 bg-blue-600' : 'cursor-not-allowed hover:bg-gray-700 bg-gray-600'"
              >
                {{ canSubmitSection4 ? 'Proceed' : 'Complete all fields' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div v-show="canShowSection5" class="hidden sm:block" aria-hidden="true">
      <div class="py-5">
        <div class="border-t border-gray-200"/>
      </div>
    </div>

    <div v-show="canShowSection5">
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <div class="px-4 sm:px-0">
            <h3 class="text-lg font-medium leading-6 text-gray-900">Additional Information</h3>
            <p class="mt-1 text-sm text-gray-600">All Sonicu devices REQUIRE the following network settings:</p>
            <p class="mt-1 text-sm text-gray-600">Destination:<br/>
              <span class="text-blue-500">dev1.sonicumonitoring.com</span> (Binary/Default)<br/>
              <span class="text-blue-500">hat1.sonicumonitoring.com</span> (HTTP/HTTPS)<br/>
              Destination Port: 80<br/>
            </p>
            <p class="mt-1 text-sm text-gray-600">Our server will send your users emails from both
              <span class="text-blue-500">@sonicu.com</span> and
              <span class="text-blue-500">@sonicumonitoring.com</span> addresses.
              Please whitelist both of these in your mail server.
            </p>
            <p class="mt-1 text-sm text-gray-600">Web clients communicate with our monitoring site via HTTPS using
              FQDN <span class="text-blue-500">www.sonicumonitoring.com</span>. All web assets will come from this
              address.
            </p>
          </div>
        </div>
        <div class="mt-5 md:col-span-2 md:mt-0">
          <div class="overflow-hidden shadow sm:rounded-md">
            <div class="bg-white px-4 py-5 sm:p-6">
              <div class="grid grid-cols-6 gap-6">

                <div class="col-span-6">
                  <label for="notes" class="block text-sm font-medium text-gray-700">Additional Notes</label>
                  <textarea rows="4"
                            v-model="section5Notes"
                            placeholder="Please enter any additional notes here."
                            name="notes"
                            id="notes"
                            class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"/>
                </div>
              </div>
            </div>
            <div class="bg-gray-50 px-4 py-3 text-right sm:px-6 mt-16">
              <button
                type="submit"
                ref="section5-button"
                class="inline-flex justify-center rounded-md border border-transparent py-2 px-4 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                :class="'cursor-pointer hover:bg-blue-700 bg-blue-600'"
              >
                Complete Form
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="my-12" ref="bottomref"></div>
  </form>

</template>


<script>
export default {
  name: "NetworkQuestionnaire",
  props:{
    csrf: {
      type: String,
      required: true
    },
    networkQuestionnaire: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      section1Complete: false,
      section2Complete: false,
      section3Complete: false,
      section4Complete: false,
      section5Complete: false,
      section1ContactName: '',
      section1ContactEmail: '',
      section1ContactPhone: '',
      section2TopologyType: false,
      section2NetworkConfiguration: false,
      section2NetworkFiltered: false,
      section3SecurityType: false,
      section3WifiSsid: '',
      section3WifiPasskey: '',
      section3EnterpriseWifiUsername: '',
      section3EnterpriseWifiPassword: '',
      section4IpAllocation: '',
      section4IpStaticRange: '',
      section4Dns: '',
      section4DnsInput: '',
      section4Protocol: 'ip-http',
      section5Notes: '',
    }
  },
  computed: {
    canSubmitSection1() {
      return this.section1ContactName.length > 0 && this.section1ContactEmail.length > 0 && this.section1ContactPhone.length > 0
    },
    canSubmitSection2() {
      return (
        (this.section2NetworkConfiguration !== false) &&
        (this.section2NetworkFiltered !== false)
      )
    },
    canSubmitSection3() {
      if (!this.askForWifiInfo) {
        return this.section3SecurityType !== false;
      } else if (this.section3SecurityType === 'network-unsecured') {
        return this.section3WifiSsid.length > 0
      } else if (this.section3SecurityType === 'network-wpa2psk') {
        return this.section3WifiSsid.length > 0 && this.section3WifiPasskey.length > 0
      } else if (this.section3SecurityType === 'network-wpa2enterprise') {
        return this.section3WifiSsid.length > 0 && this.section3EnterpriseWifiUsername.length > 0 && this.section3EnterpriseWifiPassword.length > 0
      } else {
        return false
      }
    },
    canSubmitSection4() {
      if (this.section4IpAllocation === 'ip-static' && this.section4IpStaticRange.length === 0) {
        return false;
      }
      return this.section4IpAllocation !== false && this.section4Dns !== false && this.section4Protocol !== false;
    },
    askForWifiInfo() {
      return this.section2NetworkConfiguration === 'network-preconfigured'
    },
    isSection3EnterpriseWifi() {
      return this.section3SecurityType === 'network-wpa2enterprise';
    },
    isSection3Unsecured() {
      return this.section3SecurityType === 'network-unsecured';
    },
    askForStaticIpInfo() {
      return this.section4IpAllocation === 'ip-static';
    },
    canShowSection5(){
      return this.section4Complete || (this.section3Complete && !this.askForWifiInfo);
    }
  },
  methods: {
    submitSectionOne() {
      console.log('Saving Section 1');
      if (this.canSubmitSection1) {
        this.section1Complete = true
        const el = this.$refs.bottomref;
        if(el){
          setTimeout(() => {
            el.scrollIntoView({ behavior: 'smooth' });
          }, 100);
        }
      }
    },
    submitSection2() {
      if (this.canSubmitSection2) {
        this.section2Complete = true
        const el = this.$refs.bottomref;
        if(el){
          setTimeout(() => {
            el.scrollIntoView({ behavior: 'smooth' });
          }, 100);
        }
      }
    },
    submitSection3() {
      if (this.canSubmitSection3) {
        this.section3Complete = true
        const el = this.$refs.bottomref;
        if(el){
          setTimeout(() => {
            el.scrollIntoView({ behavior: 'smooth' });
          }, 100);
        }
      }
    },
    submitSection4() {
      if (this.canSubmitSection4) {
        this.section4Complete = true
        const el = this.$refs.bottomref;
        if(el){
          setTimeout(() => {
            el.scrollIntoView({ behavior: 'smooth' });
          }, 100);
        }
      }
    },
    submitSection5() {
      if (this.canSubmitSection5) {
        this.section5Complete = true
      }
    },
    submitForm(e){
      if(!this.canShowSection5){
        e.preventDefault();
      }
    }
  }
}
</script>

<style scoped>

</style>